(function () {
    'use strict';

    angular
        .module('app.completionTypes')
        .controller('CompletionTypeDetailController', CompletionTypeDetailController);

    CompletionTypeDetailController.$inject = [
        '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'dataservice'
    ];

    function CompletionTypeDetailController($state, $stateParams,
        bsDialog, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        vm.counts = [];
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;
        vm.isNew = isNew;
        vm.preventDelete = preventDelete;
        vm.setIcon = setIcon;
        vm.iconName = "Select Icon";
        vm.bootStrapIcons = ["adjust", "align-center", "align-justify", "align-left", "align-right", "arrow-down", "arrow-left", "arrow-right", "arrow-up", "asterisk", "backward", "ban-circle", "barcode", "bell", "bold", "book", "bookmark", "briefcase", "bullhorn", "calendar", "camera", "certificate", "check", "chevron-down", "chevron-left", "chevron-right", "chevron-up", "circle-arrow-down", "circle-arrow-left", "circle-arrow-right", "circle-arrow-up", "cloud", "cloud-download", "cloud-upload", "cog", "collapse-down", "collapse-up", "comment", "compressed", "copyright-mark", "credit-card", "cutlery", "dashboard", "download", "download-alt", "earphone", "edit", "eject", "envelope", "euro", "exclamation-sign", "expand", "export", "eye-close", "eye-open", "facetime-video", "fast-backward", "fast-forward", "file", "film", "filter", "fire", "flag", "flash", "floppy-disk", "floppy-open", "floppy-remove", "floppy-save", "floppy-saved", "folder-close", "folder-open", "font", "forward", "fullscreen", "gbp", "gift", "glass", "globe", "hand-down", "hand-left", "hand-right", "hand-up", "hdd", "hd-video", "header", "headphones", "heart", "heart-empty", "home", "import", "inbox", "indent-left", "indent-right", "info-sign", "italic", "leaf", "link", "list", "list-alt", "lock", "log-in", "log-out", "magnet", "map-marker", "minus", "minus-sign", "move", "music", "new-window", "off", "ok", "ok-circle", "ok-sign", "open", "paperclip", "pause", "pencil", "phone", "phone-alt", "picture", "plane", "play", "play-circle", "plus", "plus-sign", "print", "pushpin", "qrcode", "question-sign", "random", "record", "refresh", "registration-mark", "remove", "remove-circle", "remove-sign", "repeat", "resize-full", "resize-horizontal", "resize-small", "resize-vertical", "retweet", "road", "save", "saved", "screenshot", "sd-video", "search", "send", "share", "share-alt", "shopping-cart", "signal", "sort", "sort-by-alphabet", "sort-by-alphabet-alt", "sort-by-attributes", "sort-by-attributes-alt", "sort-by-order", "sort-by-order-alt", "sound-5-1", "sound-6-1", "sound-7-1", "sound-dolby", "sound-stereo", "star", "star-empty", "stats", "step-backward", "step-forward", "stop", "subtitles", "tag", "tags", "tasks", "text-height", "text-width", "th", "th-large", "th-list", "thumbs-down", "thumbs-up", "time", "tint", "tower", "transfer", "trash", "tree-conifer", "tree-deciduous", "unchecked", "upload", "usd", "user", "volume-down", "volume-off", "volume-up", "warning-sign", "wrench", "zoom-in", "zoom-out"];
        vm.fontAwesomeIcons = ["adjust", "adn", "align-center", "align-justify", "align-left", "align-right", "ambulance", "anchor", "android", "angle-double-down", "angle-double-left", "angle-double-right", "angle-double-up", "angle-down", "angle-left", "angle-right", "angle-up", "apple", "archive", "arrow-circle-down", "arrow-circle-left", "arrow-circle-o-down", "arrow-circle-o-left", "arrow-circle-o-right", "arrow-circle-o-up", "arrow-circle-right", "arrow-circle-up", "arrow-down", "arrow-left", "arrow-right", "arrows", "arrows-alt", "arrows-h", "arrows-v", "arrow-up", "asterisk", "backward", "ban", "bar-chart-o", "barcode", "bars", "beer", "bell", "bell-o", "bitbucket", "bitbucket-square", "bitcoin", "bold", "bolt", "book", "bookmark", "bookmark-o", "briefcase", "btc", "bug", "building-o", "bullhorn", "bullseye", "calendar", "calendar-o", "camera", "camera-retro", "caret-down", "caret-left", "caret-right", "caret-square-o-down", "caret-square-o-left", "caret-square-o-right", "caret-square-o-up", "caret-up", "certificate", "chain", "chain-broken", "check", "check-circle", "check-circle-o", "check-square", "check-square-o", "chevron-circle-down", "chevron-circle-left", "chevron-circle-right", "chevron-circle-up", "chevron-down", "chevron-left", "chevron-right", "chevron-up", "circle", "circle-o", "clipboard", "clock-o", "cloud", "cloud-download", "cloud-upload", "cny", "code", "code-fork", "coffee", "cog", "cogs", "columns", "comment", "comment-o", "comments", "comments-o", "compass", "compress", "copy", "credit-card", "crop", "crosshairs", "css3", "cut", "cutlery", "dashboard", "dedent", "desktop", "dollar", "dot-circle-o", "download", "dribbble", "dropbox", "edit", "eject", "ellipsis-h", "ellipsis-v", "envelope", "envelope-o", "eraser", "eur", "euro", "exchange", "exclamation", "exclamation-circle", "exclamation-triangle", "expand", "external-link", "external-link-square", "eye", "eye-slash", "facebook", "facebook-square", "fast-backward", "fast-forward", "female", "fighter-jet", "file", "file-o", "files-o", "file-text", "file-text-o", "film", "filter", "fire", "fire-extinguisher", "flag", "flag-checkered", "flag-o", "flash", "flask", "flickr", "floppy-o", "folder", "folder-o", "folder-open", "folder-open-o", "font", "forward", "foursquare", "frown-o", "gamepad", "gavel", "gbp", "gear", "gears", "gift", "github", "github-alt", "github-square", "gittip", "glass", "globe", "google-plus", "google-plus-square", "group", "hand-o-down", "hand-o-left", "hand-o-right", "hand-o-up", "hdd-o", "headphones", "heart", "heart-o", "home", "hospital-o", "h-square", "html5", "inbox", "indent", "info", "info-circle", "inr", "instagram", "italic", "jpy", "key", "keyboard-o", "krw", "laptop", "leaf", "legal", "lemon-o", "level-down", "level-up", "lightbulb-o", "link", "linkedin", "linkedin-square", "linux", "list", "list-alt", "list-ol", "list-ul", "location-arrow", "lock", "long-arrow-down", "long-arrow-left", "long-arrow-right", "long-arrow-up", "magic", "magnet", "mail-forward", "mail-reply", "mail-reply-all", "male", "map-marker", "maxcdn", "medkit", "meh-o", "microphone", "microphone-slash", "minus", "minus-circle", "minus-square", "minus-square-o", "mobile", "mobile-phone", "money", "moon-o", "music", "outdent", "pagelines", "paperclip", "paste", "pause", "pencil", "pencil-square", "pencil-square-o", "phone", "phone-square", "picture-o", "pinterest", "pinterest-square", "plane", "play", "play-circle", "play-circle-o", "plus", "plus-circle", "plus-square", "plus-square-o", "power-off", "print", "puzzle-piece", "qrcode", "question", "question-circle", "quote-left", "quote-right", "random", "refresh", "renren", "repeat", "reply", "reply-all", "retweet", "rmb", "road", "rocket", "rotate-left", "rotate-right", "rouble", "rss", "rss-square", "rub", "ruble", "rupee", "save", "scissors", "search", "search-minus", "search-plus", "share", "share-square", "share-square-o", "shield", "shopping-cart", "signal", "sign-in", "sign-out", "sitemap", "skype", "smile-o", "sort", "sort-alpha-asc", "sort-alpha-desc", "sort-amount-asc", "sort-amount-desc", "sort-asc", "sort-desc", "sort-down", "sort-numeric-asc", "sort-numeric-desc", "sort-up", "spinner", "square", "square-o", "stack-exchange", "stack-overflow", "star", "star-half", "star-half-empty", "star-half-full", "star-half-o", "star-o", "step-backward", "step-forward", "stethoscope", "stop", "strikethrough", "subscript", "suitcase", "sun-o", "superscript", "table", "tablet", "tachometer", "tag", "tags", "tasks", "terminal", "text-height", "text-width", "th", "th-large", "th-list", "thumbs-down", "thumbs-o-down", "thumbs-o-up", "thumbs-up", "thumb-tack", "ticket", "times", "times-circle", "times-circle-o", "tint", "toggle-down", "toggle-left", "toggle-right", "toggle-up", "trash-o", "trello", "trophy", "truck", "try", "tumblr", "tumblr-square", "turkish-lira", "twitter", "twitter-square", "umbrella", "underline", "undo", "unlink", "unlock", "unlock-alt", "unsorted", "upload", "usd", "user", "user-md", "users", "video-camera", "vimeo-square", "vk", "volume-down", "volume-off", "volume-up", "warning", "weibo", "wheelchair", "windows", "won", "wrench", "xing", "xing-square", "yen", "youtube", "youtube-play", "youtube-square"];
        vm.departments = [];
        vm.showForServices = false;
        activate();

        function activate() {
            vm.showForServices = common.userService.isEmsApiType();
            var promises = [common.checkIsAdmin() , initLookups(), getItem(), getCounts()];
            return common.$q.all(promises).then(function (data) {
                
            }, function (error) { });
        }

        function cancel() {
            backToList();
        }

        function setIcon(prefix, icon) {
            vm.item.IconClass = prefix + icon;
            vm.iconName = icon;
        }

        function backToList() {
            $state.go("completiontypes.list");
        }

        function preventDelete() {
            if (vm.counts.length > 0 || $stateParams.id <= 0) {
                return true;
            }
            
            return false;
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Completion Type')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/CompletionTypes/" + vm.item.ID).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function isNew() {
            var val = $stateParams.id; 
            return val === "-1";
        }

        function getCounts() {
            if($stateParams.id > 0) {
                return dataservice.getItems('api/CompletionTypes/CountsOfEntries/' + $stateParams.id).then(function (response) {
                    vm.counts = response.data;
                    return vm.counts;
                }, function (error) { });
            }
            else {
                vm.counts = { ActiveCount: 0, Name: -1 };
            }
        }

        function getItem() {
            var val = $stateParams.id;
            if (val === '-1') {
                vm.item = {};
                vm.item.ID = -1;
                vm.item.Active = 1;
                vm.item.AvailableForTask = 1;
                vm.item.AvailableForBooking = 1;
                vm.item.AvailableForLog = 1;
                vm.item.DepartmentId = 0;
                common.setAuditInfo(vm.item);
                return vm.item;
            }

            return dataservice.getItem("api/CompletionTypes/" + val)
                .then(function (data) {
                    if (data) {
                        vm.item = data.data;
                        var parts = vm.item.IconClass.split('glyphicon-');
                        if (parts.length == 1) {
                            parts = vm.item.IconClass.split('fa-');
                        }
                        if (parts.length == 2) {
                            vm.iconName = parts[1];
                        }
                        common.setAuditInfo(vm.item);
                        common.convertDateStringsToDates(vm.item);
                        
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }


        function initLookups() {
            dataservice.getItems('api/Departments/Active').then(function (response) {
                vm.departments = response.data;
            }, function (error) { });
        }

        function save() {
            if (!vm.item.IconClass) {
                logger.error('Icon is required');
            }
            else {
                vm.isSaving = true;

                dataservice.saveItem('api/CompletionTypes', vm.item).then(function (saveResult) {
                    vm.isSaving = false;
                    backToList();
                }).catch(function (error) {
                    vm.isSaving = false;
                });
            }
            
        }
    }
})();
